import { doesCreditorInclude } from "us.common/components/MainSearch/Functions";
import { ICreditorSearchResult } from "us.common/reducers/MainSearch/Interfaces";
import { IFilterValues } from "../Interfaces";

/**
 * @function
 * @description To get the redux creditor search values filtered
 * @param creditorDetails The initial creditor search resutls - taken from Redux state
 * @param filterValues The formik input field values
 * @returns Filtered Creditor search results based on the formik input field values
 */
export const getCreditorDataFiltered = (
  creditorDetails: ICreditorSearchResult[],
  filterValues: IFilterValues
): ICreditorSearchResult[] | [] => {
  try {
    if (Array.isArray(creditorDetails)) {
      return creditorDetails?.filter((creditorData) =>
        doesCreditorInclude(creditorData, filterValues)
      );
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
